module.exports = __webpack_public_path__ + "static/media/14.bf34de9c.mp4";